/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SVGIcons } from "cms/icons/svg-icons";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { Fragment, useContext } from "react";

const RemoveIcon = (props) => {
    
    const value = props?.value;
    const { removeListItem, index } = useContext(ListItemContext);
    
    const { field } = useCurrentDynamicField();
    const list = field?.list;
    const values = field?.values;
    
    const removeItem = () => {
        removeListItem(value, index);
    };

    return (
        <Fragment>
            {list && values.length > 1 && (
                <div
                    className='remove-icon'
                    onClick={removeItem}
                >
                    <SVGIcons.common.Delete />
                </div>
            )}
        </Fragment>
    );
};

export { RemoveIcon };
